import { Grid, Typography } from "@mui/material";
import PrimaryButton from "../../components-redesign/StyledButtons/PrimaryButton";
import { useLocalTranslationState } from "../../context/AppContext/AppContext";
import { styled } from "@mui/material/styles";
import BadgeCheck from "../../loginImages/badge-check.svg";

const FormContainer = styled("form")(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  [theme.breakpoints.down('sm')]: {
    minWidth: '100%',
  },
}));

const BtnContainer = styled("div")({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-end',
  flexDirection: "column",
});

const Badge = styled("img")({
  height: 44,
  width: 'auto',
  display: 'block',
});

const TextContainer = styled("div")(({ theme }) => ({
  paddingTop: theme.spacing(5),
  alignSelf: "stretch",
}));

const HeaderContainer = styled("div")(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  paddingTop: theme.spacing(1),
}));

interface SuccessProps {
  onSubmit: () => void;
  title: string;
  subTitle1: string;
  subTitle2: string;
  buttonText: string;
}

const Success = ({
  onSubmit,
  title,
  subTitle1,
  subTitle2,
  buttonText,
}: SuccessProps) => {

  const { _translate } = useLocalTranslationState();

  const handleSubmit = async (e) => {
    e.preventDefault();
    onSubmit()
  };

  return (
    <>
      <FormContainer noValidate onSubmit={handleSubmit}>
        <HeaderContainer>
          <Badge id="badgeCheck" src={BadgeCheck} alt="badgeCheck" />
          <Typography component="h1" variant="h2" fontWeight="600">{_translate("C_AvlExport_SuccessBreadcrumb")}</Typography>
        </HeaderContainer>
        <TextContainer>
          <Typography component="h3" variant="h5" fontWeight="600">{title}</Typography>
          <Typography variant="subtitle1" fontWeight="400"
            sx={(theme) => ({
              paddingTop: theme.spacing(2),
            })}>{subTitle1}</Typography>
          <Typography variant="subtitle1" fontWeight="400">{subTitle2}</Typography>
        </TextContainer>
        <Grid container
          sx={(theme) => ({
            paddingTop: theme.spacing(4),
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'flex-start', sm: 'center' },
          })}
          wrap="nowrap"
          justifyContent="space-between">
          <Grid sx={{ width: '100%' }}>
            <BtnContainer>
              <PrimaryButton
                id="login-password-btn"
                text={buttonText}
                dataTestId="password-btn"
              />
            </BtnContainer>
          </Grid>
        </Grid>
      </FormContainer>
    </>
  );
};

export default Success;